import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { AlertService } from "./alert.service";

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html'
})

export class AlertComponent implements OnInit {
    message: any;
    @Output() click = new EventEmitter();
    constructor(private _alertService: AlertService) { }

    ngOnInit() {
        this._alertService.getMessage().subscribe(message => {
            this.message = message;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/alert/alert.component.ts